module.exports = __webpack_public_path__ + "static/media/00850- TURNOS SÁBADOS NOT SDN.65d2ab5e.pdf";